import { isObjectLike } from 'lodash'
import log from '@/logger'

const interceptorResponseSuccess = response => {
  const { status, config, data } = response
  if (!isObjectLike(data)) {
    log.warn('DATA Response Invalid', config.method, config.url, status)
    return Promise.reject() // eslint-disable-line prefer-promise-reject-errors
  }
  log.info('DATA Response', config.method, config.url, status)
  return data
}

export { interceptorResponseSuccess }
